import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService } from 'src/app/shared/service/dialog.service';
import { AuthService } from 'src/app/shared/service/auth.service';
import { AdminRolesEnum } from 'src/app/shared/enums/admin-roles.enum';
import { Messages } from 'src/app/shared/messages/messages';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { FdFieldConfigs } from 'src/app/shared/fd-form-components/fd-form-components.module';
import { filter } from 'rxjs/operators';
import { MccPhysicalPersonHistoryModel, MccPhysicalPersonModel } from '../../models/mcc-physical-person.model';

@Component({
    selector: 'app-list-mcc',
    templateUrl: './list-mcc.component.html',
    styleUrls: ['./list-mcc.component.scss'],
    standalone: false
})
export class ListMccComponent implements OnInit {

  displayedColumns =
    ['mcc', 'mccDescription', 'createdDate', 'options_edit'];

  defaultSizeItems = 10;
  formGroup: UntypedFormGroup;
  fields: FdFieldConfigs;
  totalPages: number;
  itemsNotFoundByFilter = false;

  @Input() totalItens;

  @Input() dataSource: MatTableDataSource<MccPhysicalPersonModel>;
  originalDataSource = new MatTableDataSource<MccPhysicalPersonModel>();

  @Output() changePage = new EventEmitter<PageEvent>();
  @Output() onSearch = new EventEmitter<void>();
  @Output() deleteItem = new EventEmitter<MccPhysicalPersonModel>();
  @Output() enableItem = new EventEmitter<MccPhysicalPersonModel>();
  @Output() itemDetails = new EventEmitter<MccPhysicalPersonModel>();
  

  @ViewChild('binding') binding: ElementRef;
  expandedElement: MccPhysicalPersonModel;

  constructor(
    private dialogService: DialogService,
    private authService: AuthService,
    private formBuilder: UntypedFormBuilder
  ) { }

  
  pagedData: MccPhysicalPersonModel[] = [];
  currentPageIndex: number = 0;
  currentPageSize: number = this.defaultSizeItems;

  ngOnInit(){
    this.startForms();
    this.dataSource.connect().subscribe(response => {
      if (response && response.length) {
        this.originalDataSource.data = this.dataSource.data;
        this.totalPages = Math.ceil(this.originalDataSource.data.length / this.currentPageSize);
        this.currentPageIndex = 0;
        this.updatePagedDataSource();
      }
    });
  }

  disconnect() {
    this.dataSource.disconnect();
  }
  
  startForms() {
    this.formGroup = this.formBuilder.group({
      mccFilter: [''],
    });

    this.fields = {
      mccFilter: {
        label: 'Filtrar Mcc',
        controlName: 'mccFilter'
      },
    };
  }

  get hasWriteAccess() {
    return this.authService.isUserInRoles([AdminRolesEnum.MCC_PHYSICAL_PERSON_WRITE]);
  }

  get hasValue() {
    return this.dataSource && this.dataSource.data && this.dataSource.data.length;
  }

  formatWithLeadingZeros(value: number, totalLength: number = 8): string {
    return value.toString().padStart(totalLength, '0');
  }
 
  delete(select: any) {
    this.dialogService.openConfirmDialog(Messages.CONFIRM_DELETE_ACTION, () => this.deleteItem.emit(select));
  }

  enable(select: any) {
    this.dialogService.openConfirmDialog(Messages.CONFIRM_ENABLE_ACTION, () => this.enableItem.emit(select));
  }

  detail(mccPhysicalPerson: MccPhysicalPersonModel) {
    this.itemDetails.emit(mccPhysicalPerson);
  }

  updatePagedDataSource() {
    const startIndex = this.currentPageIndex * this.currentPageSize;
    const endIndex = startIndex + this.currentPageSize;
    this.pagedData = this.originalDataSource.data.slice(startIndex, endIndex);
  }



 change(event: PageEvent): void {
    const requestedPage = event.pageIndex;
    const requestedSize = event.pageSize;

    if (requestedSize !== this.currentPageSize) {
      this.currentPageSize = requestedSize;
      this.totalPages = Math.ceil(this.originalDataSource.data.length / this.currentPageSize);
      this.currentPageIndex = 0;
    } else {
      if (requestedPage < 0) {
        this.currentPageIndex = 0;
      } else if (requestedPage >= this.totalPages) {
        this.currentPageIndex = this.totalPages - 1;
      } else {
        this.currentPageIndex = requestedPage;
      }
    }

    this.updatePagedDataSource();
  }

  applyFormatRefexFilterMccDescription(mccDescription: string):string {
    if(!mccDescription) return '';
    return /^\d{4}\s*-\s*/.test(mccDescription)
      ? mccDescription.replace(/^\d{4}\s*-\s*/, '').trim()
      : mccDescription;
  }
  
}
